// @flow

import * as React from 'react';
import styled from '@emotion/styled';

import Clickable from 'app/components/commons/Clickable';
import RadioButton from 'app/components/commons/RadioButton';

type Props = {
  hideActivePlayers: boolean,
  onToggleHideActivePlayers: () => void,
  label?: string
};

const defaultProps = {
  label: 'Hide Active'
};

const Wrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.color.panel,
  paddingLeft: theme.spacing.tiny
}));

const Label = styled.span(({ theme }) => ({
  fontSize: theme.fontSize.xsmall,
  textTransform: 'uppercase'
}));

const PlayerSwapFilterBar: React.FC<Props> = ({
  hideActivePlayers,
  onToggleHideActivePlayers,
  label
}: Props) => (
  <Wrapper>
    <Clickable onClick={onToggleHideActivePlayers}>
      <RadioButton checked={hideActivePlayers} />
      <Label>
        {'\u00a0\u00a0'}
        {label}
      </Label>
    </Clickable>
  </Wrapper>
);

PlayerSwapFilterBar.defaultProps = defaultProps;

export default PlayerSwapFilterBar;
